import React from "react";
import LeagueSheetViewer from "../organizations/AverageCatalogs/LeagueSheetViewer";
import {
  createSignupAverageProofSignedUrl,
  proofFileName,
} from "../../utility/signupAverageProof";

const AverageProofViewer = ({ isOpen, onClose, storagePath }) => (
  <LeagueSheetViewer
    isOpen={isOpen}
    onClose={onClose}
    title="Average verification"
    storagePath={storagePath || ""}
    fileName={proofFileName(storagePath)}
    createSignedUrl={createSignupAverageProofSignedUrl}
  />
);

export default AverageProofViewer;
